import type { StatusTone } from "../../../ui";

/**
 * The sales section's status vocabulary, in one place.
 *
 * Four document kinds carry eleven statuses between them and the same word has
 * to mean the same colour everywhere: a "paid" invoice in a list, in a detail
 * head and in a KPI tile is one state, not three. The tones come from the
 * CRM's five-tone scale - `ok` settled, `wt` waiting on somebody, `lt` late or
 * refused, `info` a neutral fact, `mut` inactive.
 */
const TONE: Record<string, StatusTone> = {
  draft: "mut",
  sent: "wt",
  issued: "info",
  accepted: "ok",
  paid: "ok",
  applied: "ok",
  partially_paid: "wt",
  expired: "mut",
  declined: "lt",
  overdue: "lt",
  cancelled: "mut",
};

/**
 * The tone a document status wears. Unknown statuses fall back to `mut`: a
 * status the front end has not heard of is a fact we cannot colour, and
 * guessing "ok" would paint an unpaid invoice green.
 */
export function docStatusTone(status: string): StatusTone {
  return TONE[status] ?? "mut";
}
